<div class="tag-container" *ngIf="facets">
    <div class="tags">
        <ng-container *ngFor="let facet of facets">
            <button
                class="tag"
                (click)="removeFacet(facet[0], facet[1])"
                *ngIf="
                    facet[1]
                        | replaceKey
                            : {
                                  '0': 'filter.facetText.no' | translateSafe,
                                  '1': 'filter.facetText.yes' | translateSafe
                              } as activeFacetText
                "
            >
                <app-svg-icon aria-hidden="true" iconName="close"></app-svg-icon>
                <span class="kk-visuallyhidden">
                    {{
                        'filter.buttonAriaText.removeActiveFacet'
                            | translateSafe
                                : {
                                      facet: activeFacetText
                                  }
                    }}
                </span>
                <ng-container *ngIf="facet[0] === customFilterParams.searchQuery; else defaultFacets">
                    {{ 'filter.facetText.searchWord' | translateSafe }}: {{ activeFacetText }}
                </ng-container>
                <ng-template #defaultFacets>
                    {{ facet | getGroupPrefix: facetGroups }}
                    {{ activeFacetText }}
                </ng-template>
            </button>
        </ng-container>
    </div>

    <button class="kk-icon-btn kk-icon-btn_reverse reset-button" (click)="resetFacets.emit()">
        <app-svg-icon aria-hidden="true" iconName="trash"></app-svg-icon>
        {{ 'filter.buttonText.removeActiveFilters' | translateSafe }}
    </button>
</div>
